// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"y2-z","displaySixCardTiles":"z2-z"};